import { computed } from 'mobx'
import { schema, SUPPORTED_FONTS } from 'prose-core'
import { useContext } from 'react'
import { findParentNodeOfType } from 'prosemirror-utils'

import { upsertMark } from 'common/Prose/Commands/marks'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { MONOSPACE_FONTS } from 'common/Prose/constants'
import { selectionIncludesNodeType } from 'common/Prose/Toolbar/components/Format/components/utils/selectionIncludesNodeType'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { FontFamilyType } from 'utils/fontUtils'
import { NodeSelection } from 'prosemirror-state'

export function useFontFamily() {
  const view = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacEditorState = useContext(AlmanacEditorStateContext)!
  const { activeFamilies } = almanacEditorState

  const hasCodeBlock = computed(() => almanacEditorState.selectionIncludesSomeNodeTypes(schema.nodes.code_block)).get()

  const setFontFamily = (newFont: FontFamilyType) => {
    const {
      state,
      state: { selection, tr },
      dispatch,
    } = view
    if (selection instanceof NodeSelection && 'fontFamily' in selection.node.attrs) {
      tr.setNodeMarkup(selection.from, undefined, { ...selection.node.attrs, fontFamily: newFont })
      dispatch?.(tr)
    } else if (selectionIncludesNodeType(schema.nodes.code_block, state)) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const $codeBlock = findParentNodeOfType(schema.nodes.code_block)(state.selection)!
      tr.setNodeMarkup($codeBlock.pos, undefined, $codeBlock.node.attrs, [
        ...$codeBlock.node.marks.filter((m) => m.type !== schema.marks.font_family),
        schema.marks.font_family.create({ family: newFont }),
      ])

      dispatch?.(tr)
    } else {
      upsertMark(schema.marks.font_family, { family: newFont })(state, dispatch)
    }
    view.focus()
  }

  const fontList = hasCodeBlock ? MONOSPACE_FONTS : SUPPORTED_FONTS

  return { setFontFamily, activeFamilies, hasCodeBlock, fontList }
}
